"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _tracker = require("../tracker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GTMConfigurator = function GTMConfigurator(_ref) {
  var blocketApiUrl = _ref.blocketApiUrl,
      bearerToken = _ref.bearerToken,
      credentials = _ref.credentials,
      trackingId = _ref.trackingId;
  (0, _react.useEffect)(function () {
    (0, _tracker.setup)(bearerToken, blocketApiUrl, credentials, trackingId ? trackingId : 'GTM-5VFVGGQ');
  }, [blocketApiUrl, bearerToken, credentials, trackingId]);
  return null;
};

GTMConfigurator.propTypes = {
  blocketApiUrl: _propTypes["default"].string.isRequired,
  bearerToken: _propTypes["default"].string,
  credentials: _propTypes["default"].exact({
    client_id: _propTypes["default"].string.isRequired,
    client_secret: _propTypes["default"].string.isRequired,
    grant_type: _propTypes["default"].string
  }).isRequired,
  trackingId: _propTypes["default"].string
};
var _default = GTMConfigurator;
exports["default"] = _default;
//# sourceMappingURL=GTMConfigurator.js.map